export const API_IDENTITY_URL = '/ims/api';
export const API_CORE_URL = '/core/api';
export const API_EGOV_URL = '/e-gov/api';
export const API_SECURITY_URL = `${API_IDENTITY_URL}/oauth2-providers`;
export const API_TEMPLATES_URL = '/template-engine/api';
export const API_ALIMS_FINANCE = '/alims-finance/api';
export const API_INTERACT_URL = '/interact/api';
export const API_NOTIFICATIONS_URL = '/notifications/api';
